import React, { useState, useEffect } from "react";
import { Form, FormGroup, Label, Input } from "reactstrap";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Select from "react-select";
import food10 from "./../../../../images/foods/food10.png";
import food9 from "./../../../../images/foods/food9.png";
import { TagsInput } from "react-tag-input-component";

const FoodMenuForm = ({
  PopupCommonStateTransfer,
  isView,
  ArrayPopupCommonStateTransfer,
  handleChange,
  errors,
  category,
  menuSubmenuItems,
  additemSubmenuMaster,
  onChangeCommonpopup,
  onChangeCommonpopupsetOutletvalue,
  blockInvalidChar,
  menulistitem,
  uomlist,
  selecteduomMaster,
  setSelecteduomMaster,
  setUomlist,
  uomcategory,
  selected,
  itemTag,
  specialmenulist,
  selectedspecialMenu,
  setSelectedSpecialMenu,
  selectedplanId,
  subscribeItemModalm,
  popularmenu,
  setSelectedPopularMenu,
  selectedPopularMenu,
}) => {
  // console.log("menulistitem", menulistitem);

  const [selUom, setSelUom] = useState({});

  useEffect(() => {
    let selUomLst =
      uomcategory && uomcategory.filter((obj) => obj.value == menulistitem.uom);
    //console.log("selUomLst", selUomLst);
    setSelUom(selUomLst && selUomLst.length > 0 ? selUomLst[0] : {});
  }, []);

  return (
    <>
      <div className="row">
        {/* <div className="col-sm-6 col-md-6 col-xl-6">
          <FormGroup>
            <Label for="itemname">
              Item Name<span class="text-danger">*</span>
            </Label>
            <Input
              type="text"
              name="itemname"
              id="itemname"
              placeholder="Item Name"
              maxLength="40"
              required
              autoComplete="off"
              onChange={(e) =>
                onChangeCommonpopupsetOutletvalue("itemName", e.target.value.trimStart())
              }
              value={menulistitem?.itemName}
            />
            <span style={{ color: "red" }}>{errors["itemName"]}</span>
          </FormGroup>
        </div> */}
        <div className="row">
          <div className="col-sm-4 col-md-4 col-xl-8 ">
            <FormGroup>
              <label as="a" variant="badge badge-rounded badge-danger">
                Menu ID
              </label>
              <Select
                options={
                  subscribeItemModalm === false ? specialmenulist : popularmenu
                }
                value={menulistitem?.itemName}
                closeMenuOnSelect={false}
                placeholder="choose"
                autoComplete="off"
                selected=""
                onChange={(event) => {
                  console.log("event", event);
                  setSelectedSpecialMenu(event);
                  setSelectedPopularMenu(event);
                  onChangeCommonpopupsetOutletvalue("itemName", event);
                }}
              />
              <span style={{ color: "red" }}>{errors["itemName"]}</span>
            </FormGroup>
          </div>

          {/* <div className="col-sm-4 col-md-4 col-xl-4">
            <FormGroup>
              <Label for="itemprice">
                Item price<span class="text-danger">*</span>
              </Label>
              <Input
                type="number"
                min="0"
                name="itemprice"
                id="itemprice"
                placeholder="Item price"
                required
                autoComplete="off"
                onKeyDown={blockInvalidChar}
                disabled
                // onChange={(e) => {
                //   if (e.target.value && e.target.value.length > 4) {
                //     return false;
                //   } else {
                //     onChangeCommonpopupsetOutletvalue(
                //       "itemPrice",
                //       e.target.value
                //     );
                //   }
                // }}
                // value={menulistitem?.itemPrice}
              />
              <span style={{ color: "red" }}>{errors["itemPrice"]}</span>
            </FormGroup>
          </div> */}

          <div className="col-sm-4 col-md-4 col-xl-4">
            <Label for="veg">Item Type</Label>
            <FormGroup>
              <Input
                type="radio"
                name="veg"
                id="veg"
                checked={menulistitem?.itemType}
                style={{
                  backgroundColor: menulistitem?.itemType ? "green" : "white",
                }}
                onChange={(e) => {
                  onChangeCommonpopup("itemType", true);
                }}
              />
              <Label className="ml-5" for="veg">
                Veg
              </Label>
              <img className="ml-5" src={food9} width="5%" height="5%"></img>{" "}
              <br />
              {menulistitem?.outletfoodtype == "veg,nong-veg" && (
                <>
                  <Input
                    type="radio"
                    name="veg"
                    id="nonveg"
                    checked={!menulistitem?.itemType}
                    style={{
                      backgroundColor: !menulistitem?.itemType
                        ? "green"
                        : "white",
                    }}
                    onChange={(e) => onChangeCommonpopup("itemType", false)}
                  />
                  <Label className="ml-5" for="nonveg">
                    Non-Veg
                  </Label>
                  <img
                    className="ml-5"
                    src={food10}
                    width="5%"
                    height="15%"
                  ></img>
                </>
              )}
            </FormGroup>
          </div>
        </div>
        <br />
        <br />
        <br />
        <div className="row">
          {!isView ? (
            <div className="col-sm-4 col-md-4 col-xl-4">
              <FormGroup>
                <Label for="itemfoodimg">
                  Item Food Image<span class="text-danger">*</span>
                </Label>
                <br />
                <Input
                  type="file"
                  onChange={(e) => onChangeCommonpopup("itemFoodImage", e)}
                />
              </FormGroup>
            </div>
          ) : (
            <div className="col-sm-4 col-md-4 col-xl-4">
              <FormGroup>
                <Label for="itemfoodimg">
                  Item Food Image<span class="text-danger">*</span>
                </Label>
                <br />
                <Input
                  type="file"
                  onChange={(e) => onChangeCommonpopup("itemFoodImage", e)}
                />
              </FormGroup>
              <br />
              <div>
                <img
                  src={menulistitem.itemImagePath}
                  style={{
                    width: "50px",
                    height: "50px",
                    display: "block",
                    marginLeft: "50px",
                  }}
                ></img>
              </div>
            </div>
          )}

          <div class="col-sm-4 col-md-4 col-xl-4">
            <label as="a" variant="badge badge-rounded badge-danger">
              Unit of Measure
            </label>
            <Select
              options={uomcategory}
              search
              placeholder="Uom"
              value={selUom}
              autoComplete="off"
              onChange={(event) => {
                setSelUom({ label: event.label, value: event.value });
                //  console.log("event uom",event);
                onChangeCommonpopupsetOutletvalue("uom", event.value);
              }}
            />
          </div>
          {/* { subscribeItemModalm === true &&
          <div class="col-sm-4 col-md-4 col-xl-4">
            <label as="a" variant="badge badge-rounded badge-danger">
            Select Subscription Plan 
            </label>
            <Select
              options={selectedplanId}
              search
              placeholder="planId"
              value={menulistitem?.planId.value}
              autoComplete="off"
              onChange={(event) => {
            
            // console.log("event",event.value);
                onChangeCommonpopupsetOutletvalue("planId", event.value);
              }}
            />
             <span style={{ color: "planId" }}>{errors["planId"]}</span>
          </div>
       
} */}

          <div className="col-sm-4 col-md-4 col-xl-4">
            <FormGroup>
              <Label for="itemfam">
                Item Tag<span class="text-danger">*</span>
              </Label>
              <TagsInput
                value={selected != [] && selected}
                placeHolder="Item Tag"
                onChange={(e) => {
                  /*  */
                  onChangeCommonpopupsetOutletvalue("itemTag", e);
                }}
              />
              <span style={{ color: "red" }}>{errors["itemTag"]}</span>
            </FormGroup>
          </div>

          <div className="col-sm-4 col-md-4 col-xl-4">
            <FormGroup>
              <Label for="itemqty">
                Item Description<span class="text-danger">*</span>
              </Label>
              <Input
                type="textarea"
                name="itemqty"
                id="itemqty"
                placeholder="Enter Item description"
                maxLength="35"
                required
                autoComplete="off"
                onChange={(e) =>
                  onChangeCommonpopupsetOutletvalue(
                    "itemDesc",
                    e.target.value.trimStart()
                  )
                }
                value={menulistitem?.itemDesc}
              />
              <span style={{ color: "red" }}>{errors["itemDesc"]}</span>
            </FormGroup>
          </div>
        </div>
        <br />

        {/* <div className="col-sm-6 col-md-3 col-xl-3">
          <FormGroup>
            <Label for="topRecommendation">
              Top Recomendation
            </Label> <br />
            <Input
              type="checkbox"
              name="Top Recomendation"
              id="topRecomendation"
              style={{ backgroundColor: !menulistitem?.topRecommendation ? "tomato" : "green" }}
              checked={menulistitem?.topRecommendation}
              onChange={(e) => {
                onChangeCommonpopupsetOutletvalue("topRecommendation", e.target.checked);
              }
              }
            />
          </FormGroup>
        </div> */}
        {/* <div class="col-sm-6 col-md-4 col-xl-4">
          <FormGroup>
            <label as="a" variant="badge badge-rounded badge-danger">
              TopRecommendation
            </label>
            <Select
              options={recommendoption}
              search
              placeholder="TopRecomment"

              autoComplete="off"
              onChange={(event) => {
                
                // setRecommendOption({ label: event.label, value: event.value });
                onChangeCommonpopupsetOutletvalue("topRecommendation", event.value);
                console.log("event.value", event.value);
              }}
              value={menulistitem?.topRecommedation}
            />
          </FormGroup>
        </div> */}

        <br />
        <br />

        {/* <div className="col-sm-6 col-md-4 col-xl-4">
          <FormGroup>
            <Label for="itemfam">
              Item Tag<span class="text-danger">*</span>
            </Label>
            <Input
              type="text"
              name="itemfam"
              placeholder="Item Tag"
              maxLength="40"
              required
              autoComplete="off"
              onChange={(e) =>
                onChangeCommonpopupsetOutletvalue("itemTag", e.target.value)
              }
              value={menulistitem?.itemTag}
            />
            <span style={{ color: "red" }}>{errors["itemTag"]}</span>
          </FormGroup>
        </div>
        <div className="col-sm-6 col-md-4 col-xl-4">
          <Label for="veg">Item Type</Label>
          <FormGroup>
            <Input
              type="radio" name="veg" id="veg"
              checked={menulistitem?.itemType}
              style={{ backgroundColor: menulistitem?.itemType ? "green" : "white" }}
              onChange={(e) => {
                onChangeCommonpopup("itemType", true)
              }}
            />
            <Label className="ml-5" for="veg">
              Veg
            </Label>
            <img className="ml-5" src={food9} width="5%" height="5%"></img>{" "}
            <br />
            {menulistitem?.outletfoodtype == "veg,nong-veg" &&
              <>
                <Input
                  type="radio"
                  name="veg"
                  id="nonveg"
                  checked={!menulistitem?.itemType}
                  style={{
                    backgroundColor:
                      !menulistitem?.itemType ? "green" : "white",
                  }}
                  onChange={(e) =>
                    onChangeCommonpopup("itemType", false)
                  }
                />
                <Label className="ml-5" for="nonveg">
                  Non-Veg
                </Label>
                <img className="ml-5" src={food10} width="5%" height="15%"></img>
              </>
            }
          </FormGroup>
        </div>
        <br />

        {!isView ? (
          <div className="col-sm-6 col-md-3 col-xl-3">
            <FormGroup>
              <Label for="itemfoodimg">
                Item Food Image<span class="text-danger">*</span>
              </Label>
              <br />
              <Input
                type="file"
                onChange={(e) => onChangeCommonpopup("itemFoodImage", e)}
              />
            </FormGroup>
          </div>
        ) : (
          <div className="col-sm-6 col-md-3 col-xl-3">
            <FormGroup>
              <Label for="itemfoodimg">
                Item Food Image<span class="text-danger">*</span>
              </Label>
              <br />
              <Input
                type="file"
                onChange={(e) => onChangeCommonpopup("itemFoodImage", e)}
              />
            </FormGroup>
            <br />
            <div>
              <img
                src={menulistitem.itemImagePath}
                style={{
                  width: "50px",
                  height: "50px",
                  display: "block",
                  marginLeft: "50px",
                }}
              ></img>
            </div>
          </div>
        )}

        <div className="col-sm-6 col-md-8 col-xl-8">
          <FormGroup>
            <Label for="itemqty">
              Item Description<span class="text-danger">*</span>
            </Label>
            <Input
              type="textarea"
              name="itemqty"
              id="itemqty"
              placeholder="Enter Item description"
              maxLength="35"
              required
              autoComplete="off"
              onChange={(e) =>
                onChangeCommonpopupsetOutletvalue("itemDesc", e.target.value)
              }
              value={menulistitem?.itemDesc}
            />
            <span style={{ color: "red" }}>{errors["itemDesc"]}</span>
          </FormGroup>
        </div>
      </div>
      {/* 
      <div className="col-sm-6 col-md-3 col-xl-3 row">
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <div className="col-md-6">
            <Label for="starttime">Start Time</Label>
            <TimePicker
              // autoOk
              // format="dd/MM/yyyy"
              onChange={(e) =>
                onChangeCommonpopup("startTime", e)
              }
              value={menuSubmenuItems?.startTime}
              clearable
              // maxDate={new Date()}
              placeholder="End Date"
            />
          </div>
          <div className="col-md-6">
            <Label for="endtime">End Time</Label>
            <TimePicker
              onChange={(e) =>
                onChangeCommonpopup("endTime", e)
              }
              value={menuSubmenuItems?.endTime}
            />
          </div>
        </MuiPickersUtilsProvider>
      </div> */}

        {/* <div className="col-sm-6 col-md-3 col-xl-3">
      <Label for="itemfoodimg">
        Item Food Thumbnail<span class="text-danger">*</span>
      </Label>
      <br />
      <img className="ml-5" src={food11} width="50%"></img>
    </div> */}
      </div>
    </>
  );
};
export default FoodMenuForm;
